var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.883 14.531H11.39c-.01-.036-.06-.169-.149-.398a1.8 1.8 0 01-.125-.602c0-.328.044-.643.133-.945a3.16 3.16 0 01.406-.844c.177-.265.526-.687 1.047-1.265.526-.579.79-1.055.79-1.43 0-.73-.477-1.094-1.43-1.094-.464 0-.948.232-1.454.695l-.804-1.507c.672-.526 1.554-.79 2.648-.79.844 0 1.547.235 2.11.704.567.468.851 1.09.851 1.867 0 .531-.104.982-.312 1.351-.204.365-.566.795-1.086 1.29-.516.494-.852.906-1.008 1.234a2.476 2.476 0 00-.235 1.078c0 .083.037.302.11.656zm-.664 1.063c.354 0 .653.125.898.375.25.25.375.552.375.906s-.125.656-.375.906a1.21 1.21 0 01-.898.375c-.354 0-.656-.125-.906-.375a1.235 1.235 0 01-.376-.906c0-.354.126-.656.376-.906s.552-.375.906-.375z",
    fill: "#F7F7F7"
  })));
}

export default SvgQuestion;